import React, {useState} from 'react';
import {Link, useLocation} from 'react-router-dom';

import './css/nav.css';


function Nav (){
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    const linkClass = (path) => "navlink" + (location.pathname.startsWith(path) ? " active" : "");

    return (
        <nav className="site-nav">
            <Link className="brand" to="/">
                <span className="brand-mark">
                    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="#fff" strokeWidth="1.5">
                        <path d="M3 17V8l7-4 7 4v9" strokeLinejoin="round" strokeLinecap="round"/>
                        <path d="M8 17v-5h4v5" strokeLinejoin="round" strokeLinecap="round"/>
                    </svg>
                </span>
                <span className="brand-word">Dorms <em>@</em> Brown</span>
            </Link>

            <button className="nav-toggle" type="button" aria-label="Toggle navigation" aria-expanded={isOpen}
                onClick={() => setIsOpen(current => !current)}>
                <span></span>
                <span></span>
                <span></span>
            </button>

            <div className={"nav-links" + (isOpen ? " open" : "")}>
                <Link to="/about" className={linkClass("/about")}>About</Link>
                <Link to="/dorms" className={linkClass("/dorms")}>Dorms</Link>
                <Link to="/recommend" className={linkClass("/recommend")}>Recommendations</Link>
                <Link to="/profile" className={linkClass("/profile")}>Profile</Link>
            </div>
        </nav>
    )
}

export default Nav;
